import { combineEpics } from 'redux-observable';
import { filter, tap, take, ignoreElements } from 'rxjs/operators';

import { authorizeWithOtpSuccess, loadLocalStorageSessionSuccess } from '../../features/account/reducer/session';
import * as neuroId from '../../services/neuro-id';
import { RootEpic } from '../../store/epics';

// Loads NeuroID script and links site ID on startup
const loadNeuroIdEpic: RootEpic = (action$) => {
  return action$.pipe(
    take(1),
    tap(() => neuroId.loadScript()),
    tap(() => neuroId.setLinkedSiteId()),
    ignoreElements(),
  );
};

// Set unique persistent identifier when user authenticates
const identifyNeuroIdEpic: RootEpic = (action$, state$) => {
  return action$.pipe(
    filter(
      (action) =>
        authorizeWithOtpSuccess.match(action) ||
        (loadLocalStorageSessionSuccess.match(action) && action.payload.authorized),
    ),
    tap(() => {
      const applicantId = state$.value.session.applicantId;
      if (applicantId) {
        neuroId.identify(applicantId);
      }
    }),
    ignoreElements(),
  );
};

export const neuroIdEpic = combineEpics(loadNeuroIdEpic, identifyNeuroIdEpic);
